import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';
import EmptyBlock from '../EmptyBlock';
import { NBSP } from '../../../../constants/common';

const StyledEmptyBlock = styled(EmptyBlock)`
  margin: 20px auto;
  padding: 0;
  max-width: 300px;
`;

const EmptyAboutHotel = ({ isMobile }) => (
  <StyledEmptyBlock
    isMobile={isMobile}
    icon={<Icon type="empty-search-reviews" width="166px" />}
    title="Нет информации об отеле"
    subtitle={`Этот отель новый или в${NBSP}нем отдыхало не${NBSP}так много${NBSP}туристов`}
  />
);

EmptyAboutHotel.propTypes = {
  isMobile: PropTypes.bool,
};
EmptyAboutHotel.defaultProps = {
  isMobile: false,
};

export default EmptyAboutHotel;
